/**
 * DO NOT MODIFY THIS FILE!
 * It was created by the Reefer icons generator.
 * For updates, please re-run the generator.
 */

import type { SVGProps } from 'react';

import type { IconComponentProps } from '../../icon/icon.types';
import { Icon } from '../icon';

const StarFilled = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    fill="none"
    className="Icon/Star filled"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#FFC220"
      d="M10.928 2.697a1.174 1.174 0 0 1 2.144 0l2.164 4.581c.174.37.511.625.9.684l4.839.735c.98.149 1.372 1.408.663 2.131l-3.501 3.567c-.282.287-.411.7-.344 1.106l.826 5.035c.168 1.021-.858 1.8-1.735 1.318l-4.328-2.378a1.15 1.15 0 0 0-1.112 0l-4.328 2.378c-.877.482-1.903-.297-1.735-1.318l.826-5.035a1.29 1.29 0 0 0-.343-1.106l-3.502-3.567c-.71-.723-.318-1.982.663-2.131l4.839-.735c.389-.06.726-.315.9-.684z"
      className="SVG"
    />
  </svg>
);

export const StarFilledIcon = ({
  size = 'md',
  'data-testid': testId,
  ...props
}: IconComponentProps) => {
  return (
    <Icon
      data-testid={testId || 'star-filled-icon'}
      icon={StarFilled}
      {...props}
      size={size}
    />
  );
};
